<template>
  <div>
    <div class="userContent">
      <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="80px">
        <el-form-item prop="name" label="用户名称">
          <el-input v-model="form.name" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item prop="pass" label="密码">
          <el-input v-model="form.pass" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label="确认密码">
          <el-input v-model="form.checkPass" type="password" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">立即注册</el-button>
          <!-- <el-button @click="returnLogin">使用已有账户登录</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from "md5";
export default {
  data() {
      /*
    var handleUsernameCheck = (rule, value, callback) => {
      let username = value.trim();
      if (username.length) {
        if (username.length > 10) {
          callback(new Error("用户名不能超过10个字符"));
        } else if (username.length < 4) {
          callback(new Error("用户名不能少于4个字符"));
        } else {
          //   this.$get(`user/check/${username}`).then((r) => {
          //     if (r.data) {
          //       callback()
          //     } else {
          //       this.validateStatus = 'error'
          //       callback(new Error('抱歉，该用户名已存在'))
          //     }
          //   })
        }
      } else {
        callback();
      }
    };
    */
    // var handlePasswordLevel = (rule, value, callback) => {
    //   let level = 0;

    //   // 判断这个字符串中有没有数字
    //   if (/[0-9]/.test(value)) {
    //     level++;
    //   }
    //   // 判断字符串中有没有字母
    //   if (/[a-zA-Z]/.test(value)) {
    //     level++;
    //   }
    //   // 判断字符串中有没有特殊符号
    //   if (/[^0-9a-zA-Z_]/.test(value)) {
    //     level++;
    //   }
    //   this.state.passwordLevel = level;
    //   this.state.percent = level * 30;
    //   if (level >= 2) {
    //     if (level >= 3) {
    //       this.state.percent = 100;
    //     }
    //     callback();
    //   } else {
    //     if (level === 0) {
    //       this.state.percent = 10;
    //     }
    //     callback(new Error("密码强度不够"));
    //   }
    // };
    var handlePasswordCheck = (rule, value, callback) => {
      let password = this.form.pass;
      if (value ==="") {
        callback(new Error("请输入密码"));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      else{callback()}
      
    };
    return {
    //   state: {
    //     time: 60,
    //     smsSendBtn: false,
    //     passwordLevel: 0,
    //     passwordLevelChecked: false,
    //     percent: 10,
    //     progressColor: "#FF0000"
    //   },
      form: {
        name: "",
        pass: "",
        checkPass: ""
      },
      rules: {
        name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 3, max: 10, message: '用户名在3到10个字符之间', trigger: 'blur' }
          ],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        checkPass: [{  required: true,validator: handlePasswordCheck, trigger: "blur" }]
      }
    };
  },
  methods: {
          returnLogin () {
      this.$emit('regist', 'Login')
    },
    handleSubmit () {
     this.$refs.form.validate((valid) => {
         if (valid) {
         this.$axios.post(url+"regist", {
            name: this.form.name,
            pass: md5(this.form.pass),
            roles:[]
          })
       .then((res) => {
            //alert(res.data)
            if(res.data=="success"){
            this.$message.success("注册成功")
            this.returnLogin()
            }
            else{
              this.$message.error("用户名已被注册")
            }
          }).catch(() => {
            this.$message.error('抱歉，注册账号失败')
          })
        }

     })

    },

  }
};
</script>

<style>
.crumbs-register {
  background-color: #324157;
  height: 50px;
  line-height: 50px;
}
.register-title {
  line-height: 50px;
  margin: 0 auto;
  width: 50px;
  font-size: 16px;
}
.userContent {
  width: 400px;
  margin: 0 auto;
}
.select-sex {
  width: 320px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/Regist.vue